import { useQuery } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import { commonCalsKeys } from "../query-keys";
import type { EventId, BoatCode } from "@/types/identifiers";

export { commonCalsKeys } from "../query-keys";

export function useTeamsSyncStatus(eventId: EventId) {
  return useQuery({
    queryKey: commonCalsKeys.teamStatus(eventId),
    queryFn: async () => {
      const result = await api.GET(
        "/api/events/{event_id}/releases/sync/teams",
        {
          params: { path: { event_id: eventId } },
        },
      );
      return throwIfError(result, "Failed to fetch sync status");
    },
    enabled: !!eventId,
    refetchInterval: 30000,
  });
}

export function compareCommonCals(eventId: EventId) {
  return async (boatCode: BoatCode) => {
    const result = await api.POST(
      "/api/events/{event_id}/releases/sync/{boat_code}/compare",
      {
        params: { path: { event_id: eventId, boat_code: boatCode } },
      },
    );
    return throwIfError(result, "Failed to compare common cals");
  };
}

export function syncCommonCals(eventId: EventId) {
  return async (boatCode: BoatCode) => {
    const result = await api.POST(
      "/api/events/{event_id}/releases/sync/{boat_code}/sync",
      {
        params: { path: { event_id: eventId, boat_code: boatCode } },
      },
    );
    return throwIfError(result, "Failed to sync common cals");
  };
}
